import { Link } from "react-router-dom";

import { blogPosts } from "../content/blog-posts";
import { reviewArticlePath } from "../consts/seo";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function byPublicationDate(a: { datePublished: string; slug: string }, b: { datePublished: string; slug: string }) {
  if (a.datePublished !== b.datePublished) {
    return a.datePublished < b.datePublished ? -1 : 1;
  }
  return a.slug.localeCompare(b.slug);
}

function formatReviewDate(iso: string): string {
  const [year, month, day] = iso.split("-");
  return `${Number(day)} ${MONTHS[Number(month) - 1]} ${year}`;
}

export const BlogIndex = () => {
  const reviews = [...blogPosts].sort(byPublicationDate);

  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6">
      <p className="section-label">Reviews</p>
      <h1 className="mt-2 font-display text-4xl font-semibold text-ink">Reviews</h1>
      {reviews.length === 0 ? (
        <p className="mt-10 text-muted">Reviews will be published here.</p>
      ) : (
        <ul className="review-index mt-10 space-y-4">
          {reviews.map((post) => {
            const upcoming = post.status === "coming-soon";
            return (
              <li
                key={post.slug}
                className={[
                  "group relative rounded-xl border bg-surface/70 px-5 py-4 transition duration-200",
                  "focus-within:border-accent focus-within:ring-2 focus-within:ring-accent/30",
                  upcoming
                    ? "border-dashed border-warn/50 hover:border-warn hover:bg-warn/5"
                    : "border-line/30 hover:border-accent/70 hover:bg-elevated/60",
                ].join(" ")}
              >
                <div className="flex items-center justify-between gap-3">
                  <time dateTime={post.datePublished} className="text-sm font-medium tracking-wide text-ink">
                    {formatReviewDate(post.datePublished)}
                  </time>
                  {upcoming ? (
                    <span className="rounded-full border border-warn/50 bg-warn/15 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-warn">
                      Coming soon
                    </span>
                  ) : (
                    <span
                      aria-hidden="true"
                      className="text-accent transition duration-200 group-hover:translate-x-1"
                    >
                      →
                    </span>
                  )}
                </div>
                <Link
                  to={reviewArticlePath(post.slug)}
                  className="mt-2 block font-display text-lg font-semibold leading-snug text-ink underline decoration-transparent underline-offset-4 transition duration-200 after:absolute after:inset-0 focus-visible:outline-none group-hover:text-accent group-hover:decoration-accent sm:text-xl"
                >
                  {post.title}
                </Link>
                <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted">{post.description}</p>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
